(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  function startSlideshowVideos(root = document) {
    const videos = root.querySelectorAll('.slideshow-section video');

    videos.forEach((video) => {
      if (video.dataset.autoplayInitialized === 'true') return;

      video.dataset.autoplayInitialized = 'true';

      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');

      const startVideo = () => {
        video.play().catch(() => {});
      };

      if (video.readyState >= 2) {
        startVideo();
      } else {
        video.addEventListener('canplay', startVideo, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        startSlideshowVideos();
      },
      { once: true }
    );
  } else {
    startSlideshowVideos();
  }

  document.addEventListener('shopify:section:load', (event) => {
    startSlideshowVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
